<template>
   <div class="view-associated-actions-for-cohort container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc padding-left-4Point4">
                </div>    
                <div class="col-md-5 col-lg-5">
                  <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="closeCurrentOverlay">
                    <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row margin-left-2Perc">
                  <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
                    {{selectedCohortObj.CohortName}}
                  </div>
                  <div class="col-md-12 col-lg-12 text-align-left create-element-overlay-course-title-font-styles">
                  </div>
                  <div class="col-md-12 col-lg-12 text-align-right bottom-border">
                    Total Associated LEAPS Action(s): <b>{{availableLeapsActionForCurrentGroup.length}}</b>
                </div>     
              </div>
              <div class="table-responsive margin-top-3Perc"  v-if="getAvailableLeapsActionsForCurrentCohort.length > 0">
                <table class="table table-striped">
                    <thead>
                      <tr>
                        <th class="text-align-center font-size-15px border-right col-md-1 col-lg-1">SR. No.</th>
                        <th class="text-align-center font-size-15px border-right col-md-4 col-lg-4">LEAPS Action Title</th>
                        <th class="text-align-center font-size-15px col-md-7 col-lg-7">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(actionObj, index) in getAvailableLeapsActionsForCurrentCohort" :key="actionObj.AvailableCohortActionsId">
                        <td class="border-right col-md-2 col-lg-2">{{(index + 1)}}</td>
                        <td class="border-right col-md-7 col-lg-7">{{getActionTitle(actionObj.ActionID)}}</td>
                        <td class="col-md-3 col-lg-3">
                          <a class="cursor-pointer " @click="performClickOperation($event,'delete-associated-action', actionObj)"> <u>Delete</u> </a>
                        </td>
                      </tr>
                    </tbody>
                </table>
              </div>
              <div class="margin-top-3Perc margin-bottom-2Perc font-size-17px" v-else>
                No Associated LEAPS Goals(s) found with <b>'{{selectedCohortObj.CohortName}}'</b> Cohort.
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="closeCurrentOverlay">Close</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <loader></loader>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="userConfirmation"></confirmation-alert>
    </div> 
</template>
<script>
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import { cohortService } from '@/server-util/cohort-service'
import { constants } from '@/utils/constants'
import Loader from '@/components/dashboard/Loader'
import {find, findIndex} from 'lodash'
import { leapsActionService } from '@/server-util/leaps-action-service'

export default {
  props: ['selectedCohortObj'],
  name: 'view-associated-actions-for-cohort',
  created () {
    this.getLeapsActionsList()
  },
  data: function () {
    return {
      availableLeapsActionForCurrentGroup: [],
      showAlertDialog: false,
      errorMsg: '',
      selectedOperation: '',
      selectedActionObj: null,
      prefixString: '',
      postString: '',
      showConfirmationBox: false
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'confirmation-alert': ConfirmationOverlay
  },
  methods: {
    getActionTitle: function (actionLibraryId) {
      const foundObj = find(this.$store.state.leapsActionList, (obj) => {
        return obj.ActionLibraryId === actionLibraryId
      })
      if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
        return foundObj.ActionName
      } else {
        return 'Data Not Found'
      }
    },
    getLeapsActionsList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        if (storeObj.state.leapsActionList.length === 0) {
          this.$store.state.isLoading = true
        } else {
          this.setDefaultValues()
        }
        leapsActionService
          .getLeapsActionList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              storeObj.state.leapsActionList = responseObj.data
              if (this.$store.state.isLoading === true) {
                this.setDefaultValues()
                this.$store.state.isLoading = false
              }
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS ACTION LIST'
        )
      }
    },
    setDefaultValues: function () {
      const foundObj = find(this.getAvailableLeapsActionsForCohortList, (obj) => {
        return obj.CohortId === this.selectedCohortObj.CohortId
      })
      if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
        this.availableLeapsActionForCurrentGroup = foundObj.ActionData
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    userConfirmation (value) {
      this.showConfirmationBox = false
      if (value) {
        switch (this.selectedOperation) {
          case 'delete-associated-action':
            this.deleteAssociatedLeapsAction()
            break
        }
      }
    },
    checkAndDeleteCurrentLeapsActionFromList: function () {
      const foundCohortIndex = findIndex(this.getAvailableLeapsActionsForCohortList, (obj) => {
        return obj.CohortId === this.selectedCohortObj.CohortId
      })
      if (foundCohortIndex > -1) {
        const foundActionIndex = findIndex(this.getAvailableLeapsActionsForCohortList[foundCohortIndex].ActionData, (obj) => {
          return obj.AvailableCohortActionsId === this.selectedActionObj.AvailableCohortActionsId
        })
        if (foundActionIndex > -1) {
          this.getAvailableLeapsActionsForCohortList[foundCohortIndex].ActionData.splice(foundActionIndex, 1)
        }
      }
    },
    deleteAssociatedLeapsAction: function () {
      var storeObj = this.$store
      this.$store.state.isLoading = true
      cohortService
        .deleteAssociatedLeapsActionFromCohort(
          storeObj.state.access_token,
          this.selectedActionObj.AvailableCohortActionsId
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            this.$store.state.isLoading = false
            this.checkAndDeleteCurrentLeapsActionFromList()
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            this.$store.state.isLoading = false
          }
        }, errorObj => {
          this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confirmation overlay
      this.showConfirmationBox = value
    },
    performClickOperation: function (event, operationName, selectedObj) {
      this.selectedOperation = operationName
      this.selectedActionObj = selectedObj
      switch (this.selectedOperation) {
        case 'delete-associated-action':
          this.showConfirmationBox = true
          this.prefixString = 'Are you sure you want to delete '
          this.postString = '\'' + this.getActionTitle(selectedObj.ActionID) + '\' action?'
          break
        case 'edit':
          break
      }
    },
    closeCurrentOverlay: function () {
      var objToReturn = {
        operationName: 'close_overlay',
        createdObj: null
      }
      this.$emit('updateValues', objToReturn)
    }
  },
  computed: {
    getAvailableLeapsActionsForCohortList: {
      get: function () {
        return this.$store.state.availableLeapsActionsForCohortList
      },
      set: function (newValue) {
        this.$store.state.availableLeapsActionsForCohortList = newValue
      }
    },
    getAvailableLeapsActionsForCurrentCohort: {
      get: function () {
        return this.availableLeapsActionForCurrentGroup
      }
    },
    getSelectedCohortObjValue: {
      get: function () {
        return this.selectedCohortObj
      }
    }
  }
}
</script>

<style scoped>
.padding-left-right-0Px {
  padding-left: 0px;
  padding-right: 0px;
}
.cursor-default  {
  cursor: not-allowed !important;
}
.opacity-point-2 {
  opacity: 0.2;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-17px {
  font-size: 17px !important;
}
.text-align-left {
  text-align: left !important;
}
.text-align-center {
  text-align: center !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.course-img-width-height {
  width: 350px;
  height: 150px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #f39c12;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
.margin-top-3Perc {
  margin-top: 3% !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.opacity-1 {
  opacity: 1 !important;
}
.opacity-0 {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/group/ViewAssociatedLeapsActionsForCohort.vue